import {  put, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../../components/common/apiConfig";
import { handleNotificationAlertCatch , handleNotificationAlertTrySelect } from "../../../components/method/handleNotificationAlert";

export const actionTypes = {
    select_pdf_creator_: "select_pdf_creator [Action]",
    select_pdf_creator_Loading: "select_pdf_creator_Loading [Action]",
    select_pdf_creator_Async: "select_pdf_creator_Async [Action]",
    select_pdf_creator_Empty: "select_pdf_creator_Empty [Action]",
};

const inistiaState = {
    data: {},
    total:0,
    loading: false
};

export const select_pdf_creator_reducer = (state = inistiaState, { type, payload }) => {
    switch (type) {
        case actionTypes.select_pdf_creator_:
            return {
                ...state,
                data: payload.image_file,
                total: payload.image_file ? Object?.keys(payload.image_file)?.length :0
            };
        case actionTypes.select_pdf_creator_Empty:
            return inistiaState
        case actionTypes.select_pdf_creator_Loading:
            return {
                ...state,
                loading: payload,
            };
        default:
            return state;
    }
};

function* handleWorker({ payload }) {

    yield put({ type: actionTypes.select_pdf_creator_Loading, payload: true })


    let config = {
        url: "select_request"
    };

    let data = {
        table: "brokercustomer",
        method_type: "select_real_contract",
        data: payload?.data ? payload.data : {},
    };

    try {
        let res = yield AxiosCustom(config, data);
        let isOk = handleNotificationAlertTrySelect(res);
        if (!isOk) {
            return;
        }

        
        yield put({ type: actionTypes.select_pdf_creator_, payload: res?.data?.response?.data})
    } catch {
        handleNotificationAlertCatch();
    } finally {
        yield put({ type: actionTypes.select_pdf_creator_Loading, payload: false })

    }
}

export function* workerselect_pdf_creator() {
    yield takeLatest(actionTypes.select_pdf_creator_Async, handleWorker);
}
